import { render, staticRenderFns } from "./events-handler.vue?vue&type=template&id=107ef19b&scoped=true"
import script from "./events-handler.vue?vue&type=script&lang=js"
export * from "./events-handler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ef19b",
  null
  
)

export default component.exports